export default __webpack_public_path__ + "static/media/Stopper.e3d3e0e1.svg";